import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../common/GridLayout";
import { handleDataGridExport } from "../../../common/Utils";
import DateBox from "devextreme-react/date-box";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { ABECASUSER_LOGIN_TYPE, CARRIER_LOGIN_TYPE, SCHEDULING_PERMISSIONS, hasSchedulingPermission } from "../../../common/permissions";
import { Localization } from "../../../common/Localization";
import { formatNumber } from "devextreme/localization";
import {Toolbar as MainToolbar, Item as MainItem} from 'devextreme-react/toolbar';
import {
  GetFormatedDateWithTime
} from "../../../common/Utils";
import RadioGroup from 'devextreme-react/radio-group';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

import DataGrid, {
  Column,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring,
  Format
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert, confirm } from 'devextreme/ui/dialog';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../common/concurrency';
import { MESSAGES } from '../../../common/Messages';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import PickCapacitySlotsDialog from "./pickCapacity/PickCapacitySlotsDialog";

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';
const gridKey = "5dfc21c9-7fc6-4590-8fb1-0086c41684c8";

const now = new Date();
const dateTimeLabel = { 'aria-label': 'Date Time' };
const transactionTypeFilterOptions = [
  { text: "All", value: "" },
  { text: "Shipment", value: "S" },
  { text: "Receipt", value: "R" },
];

class Scheduling extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loadIndicatorVisible: false,
      selectedItemKeys: [],
      recShipDateTime: this.props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && this.props.oidc.user.profile.LOGINTYPEID == CARRIER_LOGIN_TYPE ? now : null,
      summaryText: "Orders: 0, Gross Wt: 0, Net Wt:0, Qty Ord: 0, Qty Act: 0, Pallets: 0",
      currentLayout: "Default",
      isReadySelected: false,
      transactionTypeFilter: "",
      facilityPrefix: "",
      // WM-CARRIER-SCHED: Pick Capacity Slots popup, which replaces the carrier Apply flow.
      pickCapacityVisible: false,
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.onRecShipDateTimeChanged = this.onRecShipDateTimeChanged.bind(this);
    this.approve = this.approve.bind(this);
    this.reject = this.reject.bind(this);
    this.onRowPrepared = this.onRowPrepared.bind(this);
    this.onTransactionTypeFilterChanged = this.onTransactionTypeFilterChanged.bind(this);
    this.openPickCapacity = this.openPickCapacity.bind(this);
    this.closePickCapacity = this.closePickCapacity.bind(this);
    this.onPickCapacityApplied = this.onPickCapacityApplied.bind(this);


    var that = this;
    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Transaction.GetCarrierSchedulingData}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
    this.FMDriverReference = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Transaction.GetFMDriverReference}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  componentDidMount() {
    // Resolve the selected facility's name so its first letter can prefix the Driver Reference.
    const profile = this.props.oidc.user.profile;
    if (!profile.webUserInfo) {
      return;
    }
    const webUserInfo = JSON.parse(profile.webUserInfo);
    axios.get(
      `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabasesCompanies}?userId=${profile.sub}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
      }
    ).then((res) => {
      const companies = res.data && res.data.companies ? res.data.companies : [];
      const facility = companies.find((c) => c.value === String(webUserInfo.userCompanyId));
      if (facility && facility.text) {
        // Facility text is "Company - Name"; use the first letter of the Name part.
        const parts = facility.text.split(" - ");
        const name = parts.length > 1 ? parts.slice(1).join(" - ") : facility.text;
        const prefix = name.trim().charAt(0).toUpperCase();
        this.setState({ facilityPrefix: prefix });
      }
    }).catch(() => {
      // Leave the prefix empty if the facility can't be resolved.
    });
  }

  loadState = () => {
    return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, this.state.currentLayout);
  }

  saveState = (state) => {
    GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);
  }

  setCurrentLayout = (value) => {
    this.setState({ currentLayout: value });
  }

  renderDriverReferenceCell = (cellData) => {
    // Hidden when Rejected; otherwise show the facility prefix in front of the Driver Reference.
    if (cellData.data.recShipDatetimeApprovalStatus === "Rejected") {
      return <span></span>;
    }
    const reference = cellData.value;
    if (!reference) {
      return <span></span>;
    }
    return <span>{this.state.facilityPrefix}{reference}</span>;
  }

  renderApprovalStatusCell = (cellData) => {
    const status = cellData.value;
    // The revert-to-pending option is available to all user types.
    if (status === "Approved") {
      return (
        <span>
          {status}
          <i
            className="dx-icon dx-icon-clear"
            title="Change status to Pending Approval"
            style={{ marginLeft: "8px", cursor: "pointer", color: "#d9534f", fontSize: "12px" }}
            onClick={() => this.revertApproval(cellData.key)}
          />
        </span>
      );
    }
    return <span>{status}</span>;
  }

  revertApproval = (rowId) => {
    let result = confirm("Are you sure you want to change the status to Pending Approval?", "Confirm");
    result.then((dialogResult) => {
      if (!dialogResult) {
        return;
      }
      axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.Transaction.RevertApprovalToPending}?rowId=${rowId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      ).then((res) => {
        if (res.data.isSuccess) {
          dataGrid.current.instance().refresh();
        } else {
          alert(res.data.message, "Error");
        }
      }).catch((err) => {
        if (err?.[CONCURRENCY_HANDLED]) return;
        // A refusal is now a real 400 and lands here. This was `alert(err, "Error")`, which rendered
        // the literal text "[object Object]".
        alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
      });
    });
  }

  render() {
    return (
      <div className="h-100" style={{ overflowY: 'hidden' }}>
        <MainToolbar> 
          <MainItem location="before" locateInMenu="never" >
          <h6
                          style={{
                            color: window._env_.Color2,
                            margin:'15px'
                          }}
                        >
                          Scheduling
                        </h6>
          </MainItem>
          <MainItem location="after">
          <p style={{margin:"15px"}}><b>{this.state.summaryText}</b></p>
          </MainItem>
        </MainToolbar>
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} 
          style={{marginTop: "5px"}}
          id="gridContainer"
          remoteOperations={true}
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="WM_SchedulingGridStyle"
          onSelectionChanged={this.selectionChanged}
          onRowPrepared={this.onRowPrepared}
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" showCheckBoxesMode="always" allowSelectAll={true}/>
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
                enabled={true}
                editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Sorting mode="multiple"/>
          <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={this.loadState}
                    storageKey={gridKey}
                    customSave={this.saveState}
                />
          <Export enabled={true} allowExportSelectedData={true} />
          <Column dataField="transactionNumber" caption="Transaction #" />
          <Column dataField="transactionType" caption="Transaction Type" allowHeaderFiltering={false}/>
          <Column dataField="transactionTypeCode" visible={false} showInColumnChooser={false} defaultFilterOperation="=" />
          <Column dataField="stage" caption="Stage" allowHeaderFiltering={false}/>
          <Column dataField="carrier" caption="Carrier"/>
          {/* Read-only. The appointment is set by booking a slot in the Pick Capacity dialog, so
              this column reports the result rather than offering a second way to change it. */}
          <Column dataField="plannedReceivedShippedDatetime" caption="Planned Rec/Ship Date & Time" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" allowEditing={false}/>
          <Column dataField="actualReceivedShippedDatetime" caption="Actual Rec/Ship Date & Time" dataType="datetime"/>
          <Column dataField="recShipDatetimeApprovalStatus" caption="Approval Status " allowHeaderFiltering={false} cellRender={this.renderApprovalStatusCell}/>
          <Column dataField="fmDriverReference" caption="Driver Reference" cellRender={this.renderDriverReferenceCell}/>
          <Column dataField="container" caption={Localization.formatMessage('WMTRANSACTIONHEADER.CONTAINER', 'Container #')} visible={false} />
          <Column dataField="transactionGroup" caption={Localization.formatMessage('WMTRANSACTIONHEADER.TRANSACTIONGROUP', 'Transaction Group')} visible={false} />
          <Column dataField="reference" caption={Localization.formatMessage('WMTRANSACTIONHEADER.REFERENCE', 'P.O. No')} visible={false} />
          <Column dataField="totalNetWeight" caption="Total Net Weight" visible={false} allowHeaderFiltering={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="totalGrossWeight" caption="Total Gross Weight" visible={false} allowHeaderFiltering={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="consigneeIdentityId" caption="Consignee" visible={false} />
          <Column dataField="consigneeName" caption="Consignee Name" visible={false} />
          <Column dataField="consigneeAddress1" caption="Consignee Address 1" visible={false} />
          <Column dataField="consigneeAddress2" caption="Consignee Address 2" visible={false} />
          <Column dataField="consigneeCity" caption="Consignee City" visible={false} />
          <Column dataField="consigneeState" caption="Consignee State" visible={false} />
          <Column dataField="consigneeZip" caption="Consignee Zip" visible={false} />
          <Column dataField="consigneeCountry" caption="Consignee Country" visible={false} />
          <Column dataField="userDefinedReference1" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_1', 'Reference 1')} visible={false} />
          <Column dataField="userDefinedReference2" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Reference 2')} visible={false} />
          <Column dataField="userDefinedReference3" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_3', 'Reference 3')} visible={false} />
          <Column dataField="userDefinedReference4" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_4', 'Reference 4')} visible={false} />
          <Column dataField="userDefinedReference5" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_5', 'Reference 5')} visible={false} />
          <Column dataField="userDefinedReference6" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_6', 'Reference 6')} visible={false} />
          <Column dataField="userDefinedReference7" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_7', 'Reference 7')} visible={false} />
          <Column dataField="userDefinedReference8" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_8', 'Reference 8')} visible={false} />
          <Column dataField="userDefinedReference9" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_9', 'Reference 9')} visible={false} />
          <Column dataField="userDefinedReference10" caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_10', 'Reference 10')} visible={false} />
          <Toolbar>
            {/* <Item location="before">
            <p className="main-title" style={{paddingTop:"15px"}}>Scheduling</p>
            </Item> */}
            <Item location="before">
              <RadioGroup
                items={transactionTypeFilterOptions}
                value={this.state.transactionTypeFilter}
                valueExpr="value"
                displayExpr="text"
                layout="horizontal"
                onValueChanged={this.onTransactionTypeFilterChanged}
              />
            </Item>
            <Item>
              <LoadIndicator
                style={{
                  height: "20px",
                  width: "20px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
                visible={this.state.loadIndicatorVisible}
              />
            </Item>
            {/* Internal users only: a carrier now chooses a slot in the Pick Capacity popup. */}
            {this.props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && this.props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE
              ?
              <Item locateInMenu="auto">
                <DateBox
                  defaultValue={this.props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && this.props.oidc.user.profile.LOGINTYPEID == CARRIER_LOGIN_TYPE ? now : null}
                  inputAttr={dateTimeLabel}
                  type="datetime"
                  value={this.state.recShipDateTime}
                  onValueChanged={this.onRecShipDateTimeChanged}
                  width={200}
                />
              </Item>
              :
              ""
            }
            {/* WM-CARRIER-SCHED: replaces the carrier Apply button. The popup carries the Driver
                Reference and Same Trailer inputs that used to sit on this toolbar.

                Open to every login type - seeing the slots, booking one and overriding the carrier
                are each governed by their own permission inside the dialog. */}
            <Item locateInMenu="auto">
              <Button onClick={this.openPickCapacity} text="Pick Capacity" type="default" stylingMode="contained" disabled={!this.state.selectedItemKeys.length || this.state.isReadySelected}>
              </Button>
            </Item>
            {/* Internal (ABECAS) users keep the access they have always had; the permission
                additionally grants it to a non-internal role. */}
            {(this.props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && this.props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE)
              || hasSchedulingPermission(this.props.ReceiptReducer?.rolePermissions, SCHEDULING_PERMISSIONS.APPROVE_REJECT_SCHEDULE_REQUEST)
              ?
              <Item locateInMenu="auto">
                <Button onClick={this.approve} text="Approve" type="default" stylingMode="contained" disabled={!this.state.selectedItemKeys.length} style={{marginRight:"10px"}}>
                </Button>
                <Button onClick={this.reject} text="Reject" type="default" stylingMode="contained" disabled={!this.state.selectedItemKeys.length}>
                </Button>
              </Item>
              : ""
            }
                      <Item location="after" locateInMenu="auto">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton"/>
          </Toolbar>
        </DataGrid>

        {/* Mounted only while open so each opening re-reads the day, the facility and the shipments
            for the current selection. The Driver Reference list is the same store the toolbar used. */}
        {this.state.pickCapacityVisible && (
          <PickCapacitySlotsDialog
            visible={this.state.pickCapacityVisible}
            onHide={this.closePickCapacity}
            onApplied={this.onPickCapacityApplied}
            accessToken={accessToken}
            selectedKeys={this.state.selectedItemKeys}
            driverReferenceDataSource={this.FMDriverReference}
          />
        )}
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  // WM-CARRIER-SCHED: the carrier picks a slot in the popup instead of typing a date and pressing
  // Apply. APPLY inside the popup runs the same ApplySchedule flow with the slot's date/time.
  openPickCapacity() {
    if (!this.state.selectedItemKeys.length) {
      alert("Please, select a record first", "Error");
      return;
    }

    this.setState({ pickCapacityVisible: true });
  }

  closePickCapacity() {
    this.setState({ pickCapacityVisible: false });
  }

  onPickCapacityApplied() {
    // Clear the selection as well as refreshing. refresh() alone leaves the booked rows selected, so
    // the next row the user picked was added to them rather than replacing them - the dialog then
    // opened for both and reported their combined picks (5 booked + 2 new showing as 7). Reloading
    // the page appeared to "fix" it only because that resets this state.
    if (dataGrid.current) {
      dataGrid.current.instance().clearSelection();
      dataGrid.current.instance().refresh();
    }
    this.setState({ selectedItemKeys: [], isReadySelected: false });
  }

  approve(e) {
    if (this.state.selectedItemKeys === null || this.state.selectedItemKeys === undefined || this.state.selectedItemKeys.length == 0)
    {
      alert("Please, select a record first",
        "Error"
      );
      return;
    }

    this.setState({
      loadIndicatorVisible: true
    });

    var that = this;
    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.Transaction.ApproveSchedule}`,
      {
        keys: this.state.selectedItemKeys,
        receivedShippedDatetime:  this.state.recShipDateTime == null ? null : GetFormatedDateWithTime(this.state.recShipDateTime)
      },
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((res) => {
      that.setState({
        loadIndicatorVisible: false
      });

        if (res.data.isSuccess)
        {
        dataGrid.current.instance().refresh();
      }
      else
      {
        alert(res.data.message, "Error");
      }
    })
      .catch((err) => {
        if (err?.[CONCURRENCY_HANDLED]) return;
        // A refusal is now a real 400 and lands here. This was `alert(err, "Error")`, which rendered
        // the literal text "[object Object]".
        alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
      });
  }

  reject(e) {
    if (this.state.selectedItemKeys === null || this.state.selectedItemKeys === undefined || this.state.selectedItemKeys.length == 0)
    {
      alert("Please, select a record first",
        "Error"
      );
      return;
    }
    this.setState({
      loadIndicatorVisible: true
    });

    var that = this;
    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.Transaction.RejectSchedule}`,
      this.state.selectedItemKeys,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((res) => {
      that.setState({
        loadIndicatorVisible: false
      });

      if (res.data.isSuccess)
      {
        dataGrid.current.instance().refresh();
      }
      else
      {
        alert(res.data.message, "Error");
      }

    })
      .catch((err) => {
        if (err?.[CONCURRENCY_HANDLED]) return;
        // A refusal is now a real 400 and lands here. This was `alert(err, "Error")`, which rendered
        // the literal text "[object Object]".
        alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
      });


  }


  onRowPrepared(e) {
    if (e.rowType !== "data") return;
    const highlightColor = this.props.oidc?.user?.profile?.WMHIGHLIGHTINCOMINGORDER;
    if (!highlightColor) return;
    if (e.data.recShipDatetimeApprovalStatus !== "Approved") {
      e.rowElement.querySelectorAll("td").forEach((cell) => {
        cell.style.setProperty("background-color", highlightColor, "important");
      });
    }
  }

  selectionChanged(e) {
    
    var totalGrossWeight = 0;
    var totalNetWeight = 0;
    var totalQuantityOrder = 0;
    var totalQuantityActual = 0;
    var totalPallets = 0;
    var orders = 0;

    if (this.props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && this.props.oidc.user.profile.LOGINTYPEID == CARRIER_LOGIN_TYPE && 
      e.currentSelectedRowKeys != null && e.currentSelectedRowKeys.length === 1)
    {
      let rows =  e.component.getVisibleRows();  
      let rowIndex = e.component.getRowIndexByKey(e.currentSelectedRowKeys[0]);  
      let row = rows[rowIndex];
      if( row.data.recShipDatetimeApprovalStatus == "Approved")
      {
        alert("Cannot reschedule an already approved order", "Error");
        e.component.deselectRows(e.currentSelectedRowKeys);
        return;
      }
    }
    if (e.selectedRowsData != null)
    {
      orders = e.selectedRowsData.length;
      for (var i=0; i < e.selectedRowsData.length; i++)
      {
        if (e.selectedRowsData[i].totalGrossWeight != null)
        {
          totalGrossWeight = totalGrossWeight + e.selectedRowsData[i].totalGrossWeight;
        }

        if (e.selectedRowsData[i].totalNetWeight != null)
        {
          totalNetWeight = totalNetWeight + e.selectedRowsData[i].totalNetWeight;
        }

        if (e.selectedRowsData[i].totalQuantityOrder != null)
        {
          totalQuantityOrder = totalQuantityOrder + e.selectedRowsData[i].totalQuantityOrder;
        }


        if (e.selectedRowsData[i].totalQuantityActual != null)
        {
          totalQuantityActual = totalQuantityActual + e.selectedRowsData[i].totalQuantityActual;
        }

        if (e.selectedRowsData[i].totalPallets != null)
        {
          totalPallets = totalPallets + Math.ceil(e.selectedRowsData[i].totalPallets);
        }
      }
    }

    this.setState({
      summaryText: "Orders: " + orders + ", Gross Wt: " + formatNumber(totalGrossWeight, "#,##0.00") + ", Net Wt: " + formatNumber(totalNetWeight, "#,##0.00") + ", Qty Ord: " + formatNumber(totalQuantityOrder, "#,##0.##") + ", Qty Act: " + formatNumber(totalQuantityActual, "#,##0.##") + ", Pallets: " + formatNumber(totalPallets, "#,##0")
    });
    
    var isReadySelected = e.selectedRowsData != null && e.selectedRowsData.some(r => r.stageCode === "R");

    this.setState({
      selectedItemKeys: e.selectedRowKeys,
      isReadySelected: isReadySelected
    });
  }


  onRecShipDateTimeChanged(e) {
    this.setState({
      recShipDateTime: e.value
    });
  }

  onTransactionTypeFilterChanged(e) {
    this.setState({ transactionTypeFilter: e.value });
    const grid = dataGrid.current.instance();
    grid.columnOption("transactionTypeCode", "filterValue", e.value ? e.value : null);
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(Scheduling);
